import React from 'react';
import { Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import AnalysisPage from './pages/AnalysisPage';
import AuthPage from './components/AuthPage/AuthPage';
import ProtectedRoute from './components/Portection/ProtectedRoute';
import AdminPanel from './pages/AdminPage/Admin';

function App() {
  return (
    <Routes>
      {/* Protected route for regular users */}
      <Route element={<ProtectedRoute />}>
        <Route path="/dashboard" element={<AnalysisPage />} />
      </Route>

      {/* Protected route for admin panel */}
      <Route 
        element={<ProtectedRoute adminOnly={true} />}
      >
        <Route path="/adminpanel" element={<AdminPanel />} />
      </Route>

      {/* Public route for login */}
      <Route path="/" element={<AuthPage />} />
    </Routes>
  );
}

export default App;
